var styles = {"container":"bc-MaterialAssignmentRow__container","icon":"bc-MaterialAssignmentRow__icon","materialText":"bc-MaterialAssignmentRow__materialText","isReadyContainer":"bc-MaterialAssignmentRow__isReadyContainer","isReadyText":"bc-MaterialAssignmentRow__isReadyText"};

export { styles as default };
